/* eslint-disable */
import React, { useMemo, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_GlobalFilterTextField,
  MRT_ToggleFiltersButton,
} from 'material-react-table';

import ApiWebIcon from "web-app/src/assets/icons/button icons/API-website-button.png";
import ApiWebGrey from "web-app/src/assets/icons/button icons/API-website-button-over.png";
import PrivatePropertyIcon from "web-app/src/assets/icons/button icons/private-property-button.png";
import PrivatePropertyGreyIcon from "web-app/src/assets/icons/button icons/private-property-button-over.png";
import Property24Icon from "web-app/src/assets/icons/button icons/property-24-button.png";
import Property24GreyIcon from "web-app/src/assets/icons/button icons/property-24-button-over.png";

import {
  Box,
  Button,
  Dialog,
  ListItemIcon,
  MenuItem,
  Menu,
  LinearProgress,
  lighten,
  Select
} from '@mui/material';

import { Add, Edit, Delete, Transform } from '@mui/icons-material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as XLSX from 'xlsx';
import { Snackbar, Alert } from '@mui/material';
import FormComponent from './MaterialReactTableModals/FormComponent';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import image2 from "assets/api_images/5-load-page-image-transparent_fullpage-blue-redline-top.png";

import assets from "assets";
import PropertyProcessorForm from './MaterialReactTableModals/PropertyProcessorForm'; // Import the new component

const MAX_EXPORT_LIMIT = 5000;

const Material_React_Table = ({
  data = [],
  columns = [],
  allData = [],
  view,
  onRowUpdate,
  publish,
  api,
  PrivateProperty,
  property24,
  userInitialState,
  editTable,
  duplicate,
  brochureTable,
  updateBrochureTable,
  syncWithWebsite,
  syncWithPrivateProperty,
  syncWithProperty24,
  handleAdd,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const exportMenuOpen = Boolean(exportAnchorEl);
  const getValue = (val, fallback = 'N/A') => val ?? fallback;
  const [pdfAnchorEl, setPdfAnchorEl] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [processorOpen, setProcessorOpen] = useState(false); // State for processor dialog
  const [processedData, setProcessedData] = useState([]); // State for processed data

  const handleOpenModal = (type, rowData = null) => {
    setModalType(type);
    setSelectedRow(rowData);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };

  const handleFormSubmit = (values) => {
    if (modalType === 'edit') {
      onRowUpdate(values);
    }
    handleCloseModal();
  };

  const handleExportClick = (event) => {
    setExportAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setExportAnchorEl(null);
  };

  // Function to handle processed data from PropertyProcessorForm
  const handleProcessedData = (processedData) => {
    setProcessedData(processedData);
    // You can do something with the processed data here
    console.log('Processed data:', processedData);
  };

  const handleExport = (table, type = 'filtered') => {
    setIsExporting(true);
    let rows = [];

    if (type === 'page') {
      rows = table.getPaginationRowModel().rows.map(row => row.original);
    } else if (type === 'filtered') {
      const prePaginated = table.getPrePaginationRowModel?.() || table.getFilteredRowModel?.();
      rows = (prePaginated?.rows || []).map(r => r.original);
    } else if (type === 'all') {
      rows = allData || [];
    }

    if (!rows.length) {
      setSnackbarMessage('No data to export.');
      setSnackbarOpen(true);
      setIsExporting(false);
      return;
    }

    if (rows.length > MAX_EXPORT_LIMIT) {
      rows = rows.slice(0, MAX_EXPORT_LIMIT);
      setSnackbarMessage(`Only ${MAX_EXPORT_LIMIT} listings were exported due to size limits.`);
      setSnackbarOpen(true);
    }

    const getValue = (val, fallback = 'N/A') => val ?? fallback;

    const wb = XLSX.utils.book_new();

    const exportSheetData = rows.map(listing => {
      const webRef = getValue(listing.web_Ref_No || listing.id);
      const address = listing.address || {};
      const coords = address.coords || {};

      return {
        // Removed Unit Number, Complex Name, Address coords, Notes
        "Web Ref": webRef,
        "Created": new Date(getValue(listing.CreatedAt, Date.now())).toLocaleDateString(),
        "Status": getValue(listing.status),
        "Agent": getValue(listing.userdetials?.Name),
        "Agent Email": getValue(listing.userdetials?.email),
        "Listing Type": getValue(listing.type),
        "Property Type": getValue(listing.typeOfProperty),
        "Price": getValue(listing.price),
        // New fields per spec
        "Land Size": getValue(listing.landSize || ''),
        "GLA": getValue(listing.gla || listing.floorSize || listing.landSize || ''),
        "Owner Entity Name": getValue(listing.seller?.company || listing.seller?.entityName || ''),
        "Owner Name": getValue(listing.seller?.ownername || ''),
        "Owner Cell Number": getValue(listing.seller?.cellTel || ''),
        "Owner Work Number": getValue(listing.seller?.workTel || listing.seller?.homeTel || ''),
        "Owner Email": getValue(listing.seller?.email || ''),
      };
    });


    const notesSheetData = rows.flatMap(listing => {
      const webRef = getValue(listing.web_Ref_No || listing.id);
      const createdDate = new Date(getValue(listing.CreatedAt, Date.now())).toLocaleDateString();
      const user = getValue(listing.userdetials?.Name, 'System');

      const notes = [];

      if (listing.additionalNotes) {
        notes.push({ "Record Id": webRef, "Date": createdDate, "User": user, "Category": "Additional", "Note": listing.additionalNotes });
      }
      if (listing.mandate_notes) {
        notes.push({ "Record Id": webRef, "Date": createdDate, "User": user, "Category": "Mandate", "Note": listing.mandate_notes });
      }
      if (listing.seller?.ownerNotes) {
        notes.push({ "Record Id": webRef, "Date": createdDate, "User": user, "Category": "Owner", "Note": listing.seller.ownerNotes });
      }

      return notes;
    });

    const imagesSheetData = rows.flatMap(listing => {
      const webRef = getValue(listing.web_Ref_No || listing.id);
      return Object.values(listing.images || {}).map(imageUrl => ({
        "Web Ref": webRef,
        "Image Url": imageUrl,
      }));
    });

    const exportSheetColumnsOrder = [
      "Web Ref", "Created", "Status", "Agent", "Agent Email",
      "Listing Type", "Price", "Land Size", "GLA", "Owner Entity Name", "Owner Name", "Owner Cell Number", "Owner Work Number", "Owner Email"
    ];

    const imageSheetColumnsOrder = ["Web Ref", "Image Url"];
    const notesSheetColumnsOrder = ["Record Id", "Date", "User", "Category", "Note"];

    const addSheetToWorkbook = (dataArray, sheetName, headers = null) => {
      const ws = dataArray.length
        ? XLSX.utils.json_to_sheet(dataArray, { header: headers })
        : XLSX.utils.aoa_to_sheet([[]]);
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    };

    addSheetToWorkbook(exportSheetData, 'Export', exportSheetColumnsOrder);
    addSheetToWorkbook(imagesSheetData, 'Images', imageSheetColumnsOrder);
    addSheetToWorkbook([], 'Floor Plans', imageSheetColumnsOrder);
    addSheetToWorkbook([], 'Documents', imageSheetColumnsOrder);
    addSheetToWorkbook(notesSheetData, 'Notes', notesSheetColumnsOrder);

    XLSX.writeFile(wb, `Listings_${type}_Export.xlsx`);
    setIsExporting(false);
  };

  const getCriteriaSummary = (table) => {
    const state = table.getState();
    const columnFilters = state.columnFilters;
    const globalFilter = state.globalFilter;
    const sorting = state.sorting;
    const grouping = state.grouping;

    let listingStatus = 'All';
    let listingTypes = 'All';
    let typeOfProperty = 'ALL';
    let branches = 'All';
    let agents = 'All';
    let propertyTypes = 'All';
    let areas = 'All';
    let groupedBy = 'None';
    let sortedBy = 'None';

    columnFilters.forEach(filter => {
      if (filter.id === 'status') {
        listingStatus = filter.value || 'All';
      }
    });

    if (sorting && sorting.length > 0) {
      const primarySort = sorting[0];
      const column = table.getColumn(primarySort.id);
      if (column) {
        sortedBy = `${column.header} - ${primarySort.desc ? 'Newest First' : 'Oldest First'}`;
        if (primarySort.id === 'CreatedAt') {
          sortedBy = `Date Added - ${primarySort.desc ? 'Newest First' : 'Oldest First'}`;
        }
      }
    }

    if (grouping && grouping.length > 0) {
      groupedBy = grouping.map(id => table.getColumn(id)?.header || id).join(', ');
    }

    return `Listing Status: ${listingStatus} | Listing Types: ${listingTypes} | Branches: ${branches} | Agents: ${agents} | Property Types: ${typeOfProperty} | Areas: ${areas} | Grouped By: ${groupedBy} | Sorted By: ${sortedBy}`;
  };

  const loadImageAsBase64 = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = reject;
      img.src = assets.logo138x75black;
    });
  };

  const handleExportPDF = async (table, type = 'filtered') => {
    let rows = [];
    setIsExporting(true);

    if (type === 'page') {
      rows = table.getPaginationRowModel().rows.map(row => row.original);
    } else if (type === 'filtered') {
      const prePaginated = table.getPrePaginationRowModel?.() || table.getFilteredRowModel?.();
      rows = (prePaginated?.rows || []).map(r => r.original);
    } else if (type === 'all') {
      rows = allData || [];
    }

    if (!rows.length) {
      setSnackbarMessage('No data to export.');
      setSnackbarOpen(true);
      setIsExporting(false);
      return;
    }

    if (rows.length > MAX_EXPORT_LIMIT) {
      rows = rows.slice(0, MAX_EXPORT_LIMIT);
      setSnackbarMessage(`Only ${MAX_EXPORT_LIMIT} listings were exported due to size limits.`);
      setSnackbarOpen(true);
    }

    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.width;
    const headerHeight = 25;
    const headerColor = [0, 153, 255];

    doc.setFillColor(...headerColor);
    doc.rect(0, 0, pageWidth, headerHeight, 'F');

    try {
      const base64Logo = await loadImageAsBase64(image2);
      doc.addImage(base64Logo, 'PNG', 10, 4, 50, 17); // Adjust size/position as needed
    } catch (err) {
      setIsExporting(false);
      setSnackbarMessage("Failed to load image:", err);
      setSnackbarOpen(true);
    }

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(14);
    doc.setFont('helvetica', 'normal');

    doc.text('Commercial Activity Report', pageWidth - 14, headerHeight / 2 + 2, { align: 'right' });

    doc.setFontSize(8);
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
    const formattedTime = currentDate.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(':', '');
    doc.text(`${formattedDate}, ${formattedTime}`, pageWidth - 14, headerHeight / 2 + 10, { align: 'right' });

    doc.setTextColor(0, 0, 0);
    doc.setFont('helvetica', 'normal');

    let currentY = headerHeight + 10;

    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('REPORT CRITERIA', 14, currentY);
    currentY += 8;

    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    const criteriaSummary = getCriteriaSummary(table);
    const splitCriteria = doc.splitTextToSize(criteriaSummary, pageWidth - 28);
    doc.text(splitCriteria, 14, currentY);
    currentY += (splitCriteria.length * doc.getLineHeight()) + 10;

    // PDF: remove Branch, Suburb, OS, FW, YS, RA; add Email and GLA
    const tableBody = rows.map(listing => ([
      getValue(listing.web_Ref_No || listing.id),
      getValue(listing.status),
      getValue(listing.userdetials?.Name),
      getValue(listing.type),
      getValue(listing.typeOfProperty),
      getValue(listing.address?.description),
      getValue(listing.userdetials?.email), // Email added
      `R${getValue(listing.price)}`,
      getValue(listing.seller?.ownername),
      getValue(listing.seller?.cellTel),
      // GLA mapping: prefer listing.gla, then floorSize, then landSize
      getValue(listing.gla || listing.floorSize || listing.landSize || ''),
      getValue(listing.landSize || ''),
      getValue(listing.floorSize || ''),
    ]));

    autoTable(doc, {
      startY: currentY,
      head: [[
        'REF', 'STATUS', 'AGENT', 'TYPE', 'ADDRESS', 'EMAIL', 'PRICE',
        'SELLER', 'CONTACT', 'GLA', 'LND', 'FLR'
      ]],
      body: tableBody,
      styles: {
        fontSize: 7,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [52, 58, 64],
        textColor: 255,
        fontStyle: 'bold',
      },
      margin: { top: currentY, right: 14, bottom: 14, left: 14 },
    });

    doc.save(`Listings_${type}_Export.pdf`);
    setIsExporting(false);
  };

  const table = useMaterialReactTable({
    columns: useMemo(() => columns, [columns]),
    data: useMemo(() => data, [data]),
    enableColumnFilterModes: false,
    enableColumnOrdering: true,
    enableGrouping: true,
    enableEditing: false,
    editingMode: 'row',
    enableColumnPinning: true,
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: true,
    state: {
      pagination: {
        pageIndex: 0,
        pageSize: data.length,
      },
    },
    paginationDisplayMode: 'default',
    positionToolbarAlertBanner: 'bottom',
    muiTableBodyRowProps: {
      sx: {
        height: "36px", // thinner rows
      },
    },
    muiTableHeadCellProps: {
      sx: {
        padding: "4px 8px",
        fontSize: "0.85rem",
      },
    },

    muiTableContainerProps: {
      sx: {
        maxWidth: "100%",
        overflowX: "auto",
      },
    },

    muiTableBodyCellProps: {
      sx: {
        textAlign: 'center',
        verticalAlign: 'middle', // keeps text vertically centered too
      },
    },


    muiTableBodyCellProps: {
      sx: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        padding: "4px 8px",
        fontSize: "0.85rem",
      },
    },

    // ✅ Your table initial state
    initialState: {
      pagination: {
        pageSize: 100,
        pageIndex: 0,
      },
      showColumnFilters: false,
      showGlobalFilter: false,
      columnPinning: {
        left: ['mrt-row-expand', 'mrt-row-select'],
        right: ['mrt-row-actions'],
      },
      ...userInitialState,
    },
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
    },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [], // no options, locked to 100
      shape: 'rounded',
      variant: 'outlined',
      showFirstButton: true,
      showLastButton: true,
    },
    muiTablePaginationProps: {
      rowsPerPageOptions: [], // no options, locked to 100
      labelRowsPerPage: 'Rows per page:',
    },

    // ✅ Remove bottom toolbar & pagination completely
    renderBottomToolbar: false,

    // ✅ Row actions
    renderRowActionMenuItems: ({ row, closeMenu }) => [
      <MenuItem key="edit" onClick={() => { closeMenu(); editTable(row.original); }}>
        <ListItemIcon></ListItemIcon>Edit
      </MenuItem>,
      //
      <MenuItem key="view" onClick={() => { closeMenu(); view(row.original); }}>
        <ListItemIcon></ListItemIcon>View
      </MenuItem>,
      <MenuItem key="publish" onClick={() => { closeMenu(); publish(row.original); }}>
        <ListItemIcon></ListItemIcon>Publish Listing
      </MenuItem>,
      <MenuItem key="duplicate" onClick={() => { closeMenu(); duplicate(row.original); }}>
        <ListItemIcon></ListItemIcon>duplicate Listing
      </MenuItem>,
      <MenuItem key="View Brochure Link " onClick={() => { closeMenu(); brochureTable(row.original); }}>
        <ListItemIcon></ListItemIcon> {row.original.BrochureUrl ? "View Brochure Link" : "Create Brochure Link"}
      </MenuItem>,
      row.original.BrochureUrl && <MenuItem key="Update Brochure Link " onClick={() => { closeMenu(); updateBrochureTable(row.original); }}>
        <ListItemIcon></ListItemIcon> {"Update Brochure Link"}
      </MenuItem>,

    ],

    // ✅ Toolbar override (keeps only your top toolbar)
    renderTopToolbar: ({ table }) => (
      <Box
        sx={(theme) => ({
          backgroundColor: lighten(theme.palette.background.default, 0.05),
          display: 'flex',
          gap: '1rem',
          p: '8px',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
        })}
      >


        {/* Right Side - Export + Add */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', alignItems: 'center' }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={(e) => setExportAnchorEl(e.currentTarget)}
            endIcon={<ArrowDropDownIcon />}
            sx={{
              backgroundColor: 'white',
              borderColor: 'gray.300',
              color: 'black',
              '&:hover': {
                backgroundColor: '#f0f0f0',
                borderColor: 'gray.400',
              },
            }}
          >
            Export Listings
          </Button>

          <Menu anchorEl={exportAnchorEl} open={exportMenuOpen} onClose={handleExportClose}>
            <MenuItem onClick={() => { handleExportPDF(table, 'page'); handleExportClose(); }}>
              Current Page (PDF)
            </MenuItem>
            <MenuItem onClick={() => { handleExport(table, 'page'); handleExportClose(); }}>
              Current Page (XLS)
            </MenuItem>
            <MenuItem onClick={() => { handleExportPDF(table, 'filtered'); handleExportClose(); }}>
              Filtered Results (PDF)
            </MenuItem>
            <MenuItem onClick={() => { handleExport(table, 'filtered'); handleExportClose(); }}>
              Filtered Results (XLS)
            </MenuItem>
            <MenuItem onClick={() => { handleExportPDF(table, 'all'); handleExportClose(); }}>
              All Records (PDF)
            </MenuItem>
            <MenuItem onClick={() => { handleExport(table, 'all'); handleExportClose(); }}>
              All Records (XLS)
            </MenuItem>
            {/* Add Property Processor option to the menu */}
            <MenuItem onClick={() => { setProcessorOpen(true); handleExportClose(); }}>
              Process Property Data
            </MenuItem>
          </Menu>

          <Button variant="contained" color="info" onClick={() => handleAdd()}>
            Add
          </Button>
        </Box>
      </Box>
    ),
  });

  return (
    <>
      <MaterialReactTable table={table} />
      {isExporting && (
        <Box sx={{ width: '100%' }}>
          <LinearProgress color="info" />
        </Box>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="warning" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog open={isModalOpen} onClose={handleCloseModal} fullWidth maxWidth="sm">
        {isModalOpen && (
          <FormComponent
            modalType={modalType}
            onClose={handleCloseModal}
            onSubmit={handleFormSubmit}
            data={selectedRow}
            columns={columns}
          />
        )}
      </Dialog>

      {/* Property Processor Dialog */}
      <PropertyProcessorForm
        open={processorOpen}
        onClose={() => setProcessorOpen(false)}
        rows={allData}
        onProcessed={handleProcessedData}
      />
    </>
  );
};

export default Material_React_Table;